import { render, staticRenderFns } from "./mexpansion.vue?vue&type=template&id=165f4601&scoped=true&"
import script from "./this.js?vue&type=script&lang=js&"
export * from "./this.js?vue&type=script&lang=js&"
import style0 from "./mexpansion.vue?vue&type=style&index=0&id=165f4601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165f4601",
  null
  
)

export default component.exports